import { render, staticRenderFns } from "./ASINsCompare.vue?vue&type=template&id=5f1df224&scoped=true"
import script from "./ASINsCompare.vue?vue&type=script&lang=js"
export * from "./ASINsCompare.vue?vue&type=script&lang=js"
import style0 from "./ASINsCompare.vue?vue&type=style&index=0&id=5f1df224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1df224",
  null
  
)

export default component.exports